module.exports = __webpack_public_path__ + "static/img/book_mini_qrcode.36f25002.png";